import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type ApproveCampaignResponse = {
    result: string;
}

type UseApproveCampaignResponse = [
    (data: CampaignObject) => Promise<ApproveCampaignResponse | null>,
    {
        value?: ApproveCampaignResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useApproveCampaign = (): UseApproveCampaignResponse => {
    
    const [post, postState] = usePost<ApproveCampaignResponse, CampaignObject>({
        url: `campaign/approve-campaign`
    })

    const approveCampaign = async (
        data : CampaignObject
    ) : Promise<ApproveCampaignResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [approveCampaign, postState];
};